import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-primary/5 via-background to-background overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 border border-primary/20 rounded-full mb-6">
            <Icon name="Shield" size={16} className="text-primary" />
            <span className="text-sm font-medium text-primary">Plataforma Certificada para Profesionales</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
            Consultoría Profesional de VIN
            <br />
            <span className="text-primary">para la Industria Automotriz</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
            Decodificación en tiempo real, datos completos de vehículos, auditorías detalladas y gestión de usuarios. 
            La solución integral para profesionales automotrices en México.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link to="/login-and-authentication">
              <Button variant="default" size="lg" iconName="LogIn" className="w-full sm:w-auto">
                Iniciar Sesión
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg" 
              iconName="MessageCircle" 
              onClick={scrollToContact}
              className="w-full sm:w-auto"
            >
              Solicitar Información
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircle2" size={18} className="text-success" />
              <span>Datos Verificados</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Lock" size={18} className="text-success" />
              <span>Seguridad Certificada</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={18} className="text-success" />
              <span>Soporte 24/7</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="MapPin" size={18} className="text-success" />
              <span>Servicio en México</span>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="bg-card border border-border rounded-lg p-6 text-center shadow-elevation">
            <div className="text-3xl md:text-4xl font-bold text-primary mb-2">50K+</div>
            <div className="text-sm text-muted-foreground">Consultas Procesadas</div>
          </div>
          <div className="bg-card border border-border rounded-lg p-6 text-center shadow-elevation">
            <div className="text-3xl md:text-4xl font-bold text-primary mb-2">99.9%</div>
            <div className="text-sm text-muted-foreground">Precisión de Datos</div>
          </div>
          <div className="bg-card border border-border rounded-lg p-6 text-center shadow-elevation">
            <div className="text-3xl md:text-4xl font-bold text-primary mb-2">&lt;2s</div>
            <div className="text-sm text-muted-foreground">Tiempo de Respuesta</div>
          </div>
          <div className="bg-card border border-border rounded-lg p-6 text-center shadow-elevation">
            <div className="text-3xl md:text-4xl font-bold text-primary mb-2">500+</div>
            <div className="text-sm text-muted-foreground">Empresas Confiando</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;